// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "7f1667d9805cd9bee14187744c08263ddafc17a9/static/css/" + chunkId + "." + {"725":"84c1fc5e","831":"583e16c7","854":"36854e5e"}[chunkId] + ".chunk.css";
};